module.exports = __webpack_public_path__ + "static/media/generic-avatar.b6681619.png";